/* eslint-disable no-nested-ternary */
import { useState } from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import CircleIcon from "@mui/icons-material/Circle";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import { useLocation, useNavigate } from "react-router-dom";
import { useStateContext } from "contexts/ContextProvider";
import ChangePasswordModal from "modals/smea/miscellaneous/ChangePasswordModal";
import links from "./sidebarlinks";

const openedMixin = (theme, width) => ({
  width,
  background: "#111145",
  borderRadius: "20px",
  // background: "linear-gradient(60deg, #2b2b2b, #686868, #2b2b2b)",
  // background:
  //   "linear-gradient(60deg, #FFD8B6, #FFE1BD, #FFEBC4, #FFF4CA, #FFFDD1)",
  // background:
  //   "linear-gradient(40deg, rgba(15, 15, 15, 1), rgba(44, 42, 42, 1), rgba(82, 79, 79, 0.9))",
  // background:
  //   "linear-gradient(40deg, rgba(66, 201, 116, 0.9), rgba(59, 152, 184, 1), rgba(26, 214, 164, 0.9))",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  scrollbarWidth: "0.3rem",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    width: "0.3rem",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "gray",
  },
});

const closedMixin = (theme) => ({
  background: "#111145",
  borderRadius: "20px",
  // background: "linear-gradient(60deg, #2b2b2b, #686868, #2b2b2b)",
  // background: "linear-gradient(40deg, #e963fd, #8233c5, #274b74)",
  // background:
  //   "linear-gradient(40deg, #dcaf88, #eecda5, #e8c786, #f3e5ad, #f6f3b1)",
  // background:
  //   "linear-gradient(40deg, rgba(66, 201, 116, 0.9), rgba(59, 152, 184, 1), rgba(26, 214, 164, 0.9))",
  width: `calc(${theme.spacing(7)} + 1px)`,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  scrollbarWidth: "0.3rem",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    width: "0.3rem",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "gray",
  },
  "@media (max-width: 600px)": {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  "@media (max-width: 380px)": {
    width: 0,
  },
});

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ width, theme, open }) => ({
  width,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  overflow: "auto",
  scrollbarWidth: "thin",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    width: "0.5rem",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#53FDFD",
  },
  ...(open && {
    ...openedMixin(theme, width),
    "& .MuiDrawer-paper": openedMixin(theme, width),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function SideBar({
  themeProp,
  drawerWidth,
  drawerOpenStatus,
  openDrawerFunction,
  closeDrawerFunction,
}) {
  const {
    auth,
    setAuth,
    setSchoolsCR,
    setSchoolsCRCount,
    setSubjectData,
    setSubjectCRCount,
    setGradeLevelData,
    setGradeLevelCRCount,
  } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState();

  const handleNavigate = (link) => {
    navigate(`/${link || ""}`);
  };

  const handleLogout = () => {
    const confirm = window.confirm("Are you sure you want to log out?");

    if (confirm) {
      setAuth(null);
      setSchoolsCR([]);
      setSchoolsCRCount(0);
      setSubjectData([]);
      setSubjectCRCount(0);
      setGradeLevelData([]);
      setGradeLevelCRCount(0);
      localStorage.clear();
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#2e3887",
        zIndex: 100,
        position: "fixed",
        overflow: "auto",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          width: "0.5rem",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#53FDFD",
        },
      }}
    >
      <ChangePasswordModal open={open} handleClose={() => setOpen(false)} />
      <StyledDrawer
        variant="permanent"
        width={drawerWidth}
        theme={themeProp}
        open={drawerOpenStatus}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {drawerOpenStatus && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#fff",
                }}
              >
                LOADGAT
              </Typography>
            </Box>
          )}

          <DrawerHeader theme={themeProp}>
            <IconButton
              onClick={
                drawerOpenStatus ? closeDrawerFunction : openDrawerFunction
              }
            >
              {drawerOpenStatus ? (
                <ChevronLeftIcon sx={{ color: "#fff" }} />
              ) : (
                <MenuIcon sx={{ color: "#fff" }} />
              )}
            </IconButton>
          </DrawerHeader>
        </Box>
        <Divider
          sx={{
            backgroundColor: "#fff",
          }}
        />
        <List
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
            "@media (min-height: 1920px)": {
              mt: 6,
            },
          }}
        >
          <Box
            sx={{
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              "&::-webkit-scrollbar": {
                width: "2px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "gray",
              },
            }}
          >
            {links.map(
              (item) =>
                (item.role === "superadmin" || // Display items for superadmin to all users
                  (auth?.role === "admin" && item.role === "admin") || // Display items for admin to admin users
                  (auth?.role !== "teacher" && item.role === "users") ||
                  (auth?.role === "teacher" && item.role === "teacher")) && (
                  <ListItem
                    key={item.title}
                    disablePadding
                    sx={{ display: "block" }}
                  >
                    {/* eslint-disable-next-line no-nested-ternary */}
                    <Box
                      sx={{
                        ml: drawerOpenStatus ? 2 : 0,
                        my: 2,
                        color: "#fff",
                      }}
                    >
                      {drawerOpenStatus ? (
                        <Typography>{item.title}</Typography>
                      ) : (
                        <Box />
                        //   <CircleIcon sx={{ fontSize: "8px" }} />
                        // </Box>
                        // <Divider
                        //   sx={{
                        //     backgroundColor: "#fff",
                        //   }}
                        // />
                      )}
                    </Box>

                    {item.links.map((link) => (
                      <Tooltip
                        title={!drawerOpenStatus && link.name}
                        placement="right"
                      >
                        <ListItemButton
                          onClick={() =>
                            handleNavigate(
                              auth?.role === "teacher" &&
                                link.path === "dashboard"
                                ? "school-dashboard"
                                : auth?.role === "admin" &&
                                  link.path === "dashboard"
                                ? link.path
                                : link.path
                            )
                          }
                          sx={{
                            minHeight: 48,
                            justifyContent: drawerOpenStatus
                              ? "initial"
                              : "center",
                            px: 2.5,

                            backgroundColor:
                              `/${link.path}` === location.pathname
                                ? "lightgray"
                                : `/${link.path}` === "/dashboard" &&
                                  auth?.role === "teacher" &&
                                  location.pathname === "/school-dashboard"
                                ? "lightgray"
                                : "transparent",

                            "&:hover": {
                              backgroundColor: "gray",
                              color: "black",
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              // color: "black",
                              minWidth: 0,
                              mr: drawerOpenStatus ? 3 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color:
                                  `/${link.path}` === location.pathname
                                    ? "black"
                                    : `/${link.path}` === "/dashboard" &&
                                      auth?.role === "teacher" &&
                                      location.pathname === "/school-dashboard"
                                    ? "black"
                                    : "#fff",
                              }}
                            >
                              {link.icon}
                            </Typography>
                          </ListItemIcon>
                          <ListItemText
                            sx={{
                              opacity: drawerOpenStatus ? 1 : 0,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color:
                                  `/${link.path}` === location.pathname
                                    ? "black"
                                    : `/${link.path}` === "/dashboard" &&
                                      auth?.role === "teacher" &&
                                      location.pathname === "/school-dashboard"
                                    ? "black"
                                    : "#fff",
                              }}
                            >
                              {link.name}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </Tooltip>
                    ))}
                  </ListItem>
                )
            )}
          </Box>

          <Box>
            <Divider
              sx={{
                backgroundColor: "#fff",
                my: 2,
              }}
            />
            <Tooltip title={!drawerOpenStatus && "Home"} placement="right">
              <ListItemButton
                onClick={() => handleNavigate()}
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpenStatus ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    backgroundColor: "gray",
                    color: "black",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: drawerOpenStatus ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#fff",
                    }}
                  >
                    <HomeIcon />
                  </Typography>
                </ListItemIcon>
                <ListItemText
                  sx={{
                    opacity: drawerOpenStatus ? 1 : 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#fff",
                    }}
                  >
                    Home
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </Tooltip>
            <Tooltip
              title={!drawerOpenStatus && "Change Password"}
              placement="right"
            >
              <ListItemButton
                onClick={() => setOpen(true)}
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpenStatus ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    backgroundColor: "gray",
                    color: "black",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: drawerOpenStatus ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#fff",
                    }}
                  >
                    <ManageAccountsIcon />
                  </Typography>
                </ListItemIcon>
                <ListItemText
                  sx={{
                    opacity: drawerOpenStatus ? 1 : 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#fff",
                    }}
                  >
                    Change Password
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </Tooltip>
            <Tooltip title={!drawerOpenStatus && "Logout"} placement="right">
              <ListItemButton
                onClick={() => handleLogout()}
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpenStatus ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    backgroundColor: "gray",
                    color: "black",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: drawerOpenStatus ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#fff",
                    }}
                  >
                    <LogoutIcon />
                  </Typography>
                </ListItemIcon>
                <ListItemText
                  sx={{
                    opacity: drawerOpenStatus ? 1 : 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#fff",
                    }}
                  >
                    Logout
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </Tooltip>
          </Box>
        </List>
      </StyledDrawer>
    </Box>
  );
}

export default SideBar;
